<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="报价员姓名">
              <el-input
                clearable
                v-model="queryParamForm.realName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="报价员手机">
                <el-input
                clearable
                v-model="queryParamForm.username"
              ></el-input>
            </el-form-item>
          </el-col>
           <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="回收商名称">
                <el-input
                clearable
                v-model="queryParamForm.serviceName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getListQuoteSearch"
              >查询</el-button
            >
            <el-button type="primary" @click="addBasePrice">创建</el-button>
            <!-- <el-button type="primary">批量导出</el-button> -->
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="code" label="编号"> </el-table-column>
        <el-table-column prop="realName" label="报价员">
        </el-table-column>
        <el-table-column prop="username" label="手机号"> </el-table-column>
        <el-table-column prop="serviceName" label="所属回收商"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="merchantManageFlag" label="报价员角色" v-if="userInfo.roleId==1">
          <template slot-scope="scope">
            <span v-if="scope.row.merchantManageFlag===1">管理员</span>
            <span v-else>普通报价员</span>
          </template>
        </el-table-column>
        <el-table-column prop="pricePermissionFlag" label="价格标志位" v-if="userInfo.roleId==1">
          <template slot-scope="scope">
            <span v-if="scope.row.pricePermissionFlag === 0 && scope.row.serviceId===1">查看原始价和成交价</span>
            <span v-else>原始价</span>
          </template>
        </el-table-column>
        <el-table-column prop="levelNum" label="级别">
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">启用</span>
            <span v-else>不启用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
              >编辑</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 1)"
              type="text"
              size="small"
              v-if="scope.row.status === 0"
              >启用</el-button
            >
            <el-button
              @click="changeStatus(scope.row, 0)"
              type="text"
              size="small"
              style="color: red;"
              v-else
              >不启用</el-button
            >
             <el-button @click="deleteUser(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog
      :title="
        dlgType === 'change'
          ? '编辑报价员'
          : '新建报价员'
      "
      :visible.sync="isDlg"
      width="700px"
    >
      <div style="margin: 20px;">
        <div>
          <el-form
            ref="editServiceProviderForm"
            :model="editServiceProviderForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-form-item label="编号" v-if="dlgType === 'change'">
              <el-input
                clearable
                v-model="editServiceProviderForm.code"
                :disabled="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="名称" prop="realName">
               <el-input clearable v-model="editServiceProviderForm.realName"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="username">
              <el-input clearable v-model="editServiceProviderForm.username"></el-input>
            </el-form-item>
            <el-form-item
              label="所属回收商"
              prop="serviceId"
            >
              <el-select
                style="width:100%"
                v-model="editServiceProviderForm.serviceId"
                :loading="loading"
              >
                <el-option
                  v-for="item in queryServiceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item v-if="editServiceProviderForm.serviceId==1 && userInfo.roleId==1">
               <el-radio v-model="editServiceProviderForm.pricePermissionFlag" :label="0">原始价和成交价</el-radio>
               <el-radio v-model="editServiceProviderForm.pricePermissionFlag" :label="1">原始价</el-radio>
            </el-form-item>
            <el-form-item v-if="userInfo.roleId==1">
               <el-radio v-model="editServiceProviderForm.merchantManageFlag" :label="0">普通报价员</el-radio>
               <el-radio v-model="editServiceProviderForm.merchantManageFlag" :label="1">管理员</el-radio>
            </el-form-item>
            <el-form-item label="级别" prop="levelNum" v-if="editServiceProviderForm.serviceId==1">
              <el-input clearable v-model="editServiceProviderForm.levelNum" placeholder="数值越大，级别越高"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button
            type="primary"
            style="margin: 30px 20px;"
            @click="submitEditor"
            >确定</el-button
          >
          <el-button style="margin: 10px 20px;" @click="closeEditormodelDlg"
            >暂不</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      // 查询数据
      queryParamForm: {
        realName: null,
        username: null,
        serviceName:null
      },
      systemQuoteOptions:[{id:0,name:"否"},{id:1,name:"是"}],
      userInfo:{},

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据

      isDlg: false,
      editServiceProviderForm: {
        id: null,
        realName: null,
        serviceId: null,
        username: null,
        password:"123456",
        pricePermissionFlag:0
      },

      editorFormRules: {
        realName: [
          { required: true, message: "请输入报价员名称", trigger: "change" },
        ],
        username: [
          { required: true, message: "请输入手机号", trigger: "change" },
        ],
        serviceId: [{ required: true, message: "请选择回收商", trigger: "change" }],
      },

      dlgType: "change",

      // 选择
      loading: false,

      queryServiceList: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    //删除用户
    deleteUser(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteUser({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getListQuoteSearch()
          }
      })
      })
   
    },
      //回收商集合
    getServiceList() {
      let self = this;
      this.$api.getValidHjxServiceProvider().then((res) => {
        self.queryServiceList = res.data || [];
      });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getListQuoteSearch();
    },

    // 获取表格数据
    getListQuoteSearch() {
      let self = this;
      self.$api
        .listQuoteSearch({
          page: self.currentPage,
          size: self.pageSize,
          realName: self.queryParamForm.realName || null,
          username: self.queryParamForm.username || null,
          serviceName: self.queryParamForm.serviceName || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addBasePrice() {
      this.dlgType = "new";
      this.editServiceProviderForm=this.$options.data().editServiceProviderForm;
      this.$nextTick(()=>{
          this.$refs['editServiceProviderForm'].clearValidate()
      })
      this.isDlg = true;
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.dlgType = "change";
      self.editServiceProviderForm = JSON.parse(JSON.stringify(row));
      this.isDlg = false;
      this.$nextTick((e) => {
        self.isDlg = true;
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editServiceProviderForm"].validate((valid) => {
        if (valid) {
          let params = this.editServiceProviderForm;
          self.$api.updateQuoteUser(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getListQuoteSearch();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      row.modelId = null;
      this.$api.updateQuoteUser(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getListQuoteSearch();
        }
      });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getListQuoteSearch();
    self.getServiceList();
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')).data
  },
};
</script>
<style lang="less" scoped>
</style>
